import React, { useEffect } from "react";

export const Click2Logo = ({ className = "" }) => (
  <svg viewBox="0 0 760 210" className={className} role="img" aria-label="Click2Inbound Call Center Service" data-testid="c2i-logo">
    <text x="0" y="120" fill="#FFFFFF" fontFamily="'Outfit', sans-serif" fontWeight="900" fontSize="112" letterSpacing="-4">CLICK</text>
    <g transform="translate(318 0)">
      <path d="M8 92 a52 52 0 0 1 104 0" fill="none" stroke="#E50914" strokeWidth="10" strokeLinecap="round" />
      <rect x="0" y="84" width="22" height="40" rx="9" fill="#E50914" />
      <rect x="98" y="84" width="22" height="40" rx="9" fill="#E50914" />
      <path d="M109 124 q0 34 -30 36" fill="none" stroke="#E50914" strokeWidth="6" strokeLinecap="round" />
      <rect x="62" y="154" width="20" height="12" rx="6" fill="#E50914" />
      <text x="60" y="134" textAnchor="middle" fill="#E50914" fontFamily="'Outfit', sans-serif" fontWeight="900" fontSize="92">2</text>
    </g>
    <text x="452" y="120" fill="#FFFFFF" fontFamily="'Outfit', sans-serif" fontWeight="300" fontSize="64" letterSpacing="2">INBOUND</text>
    <text x="6" y="196" fill="#E50914" fontFamily="'Outfit', sans-serif" fontWeight="700" fontSize="26" letterSpacing="14">CALL CENTER SERVICE</text>
  </svg>
);

export default function Click2Home() {
  useEffect(() => { document.title = "Click2Inbound – Call Center Service"; }, []);
  return (
    <main className="min-h-screen bg-black grid place-items-center px-6" data-testid="c2i-home">
      <div className="w-full max-w-3xl c2i-fade">
        <Click2Logo className="w-full h-auto" />
      </div>
      <p className="fixed bottom-5 inset-x-0 text-center text-[11px] tracking-[0.3em] text-white/30 uppercase" data-testid="c2i-footer">© {new Date().getFullYear()} Click2Inbound</p>
    </main>
  );
}
